var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dheader'),_vm._m(0),_c('div',{staticClass:"subMain"},_vm._l((_vm.list),function(i,idx){return _c('img',{key:idx,staticClass:"main-img",attrs:{"src":i,"alt":""}})}),0),_c('footer2')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('div',{staticClass:"productDiv"},[_c('h1',[_vm._v("产品中心")])])])
}]

export { render, staticRenderFns }